export class SnailyError extends Error {
	#metadata: unknown

	constructor(message: string, metadata?: unknown) {
		super(message)
		this.name = 'SnailyError'
		this.#metadata = metadata

		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, SnailyError)
		}
	}

	get metadata(): unknown {
		return this.#metadata
	}

	toString(): string {
		return `${super.toString()}; Metadata: ${JSON.stringify(this.#metadata)}`
	}
}
